// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__HlJm+","loadingAnimation":"CircularProgress_loadingAnimation__idH8n"};